const areas = [
  { city: 'Nazareth', state: 'PA', note: 'Home Studio', primary: true },
  { city: 'Bethlehem', state: 'PA', note: '~10 miles' },
  { city: 'Easton', state: 'PA', note: '~12 miles' },
  { city: 'Allentown', state: 'PA', note: '~16 miles' },
  { city: 'Northampton', state: 'PA', note: '~8 miles' },
  { city: 'Bangor', state: 'PA', note: '~10 miles' },
];

const ServiceAreas = () => {
  return (
    <section className="py-20 md:py-28 relative" style={{ background: '#0e0e0e' }}>
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(255,67,34,0.3), transparent)' }} />

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

          {/* Left */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-8 bg-artden-coral" />
              <span className="section-label">Find Us</span>
            </div>
            <h2 className="font-cormorant font-medium text-white leading-[1.0] tracking-tight mb-5" style={{ fontSize: 'clamp(2.2rem, 4.5vw, 4rem)' }}>
              Art Classes Near You<br />
              <em className="font-light italic" style={{ color: '#ff4322' }}>in Nazareth, PA</em>
            </h2>
            <p className="font-outfit text-artden-muted text-base leading-relaxed mb-8">
              Art Den Studio is located at{' '}
              <strong className="text-white">37 E Belvidere Street in Nazareth, PA</strong>, serving creative souls across the Lehigh Valley and Northampton County.
            </p>

            {/* Area pills */}
            <div className="flex flex-wrap gap-2.5 mb-8">
              {areas.map((area, i) => (
                <div
                  key={i}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-outfit font-medium ${area.primary ? 'text-white' : 'border border-white/15 text-white/60 hover:border-artden-coral/50 hover:text-white transition-all'}`}
                  style={area.primary ? { background: '#ff4322' } : {}}
                >
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-map-pin-2-fill text-xs"></i>
                  </span>
                  {area.city}, {area.state}
                  {area.primary && <span className="text-white/70 text-xs ml-0.5">★ Home</span>}
                </div>
              ))}
            </div>

            {/* Address card */}
            <div className="rounded-xl border border-white/8 p-5" style={{ background: '#1a1a1a' }}>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg shrink-0" style={{ background: 'rgba(255,67,34,0.12)' }}>
                  <i className="ri-store-2-line text-artden-coral"></i>
                </div>
                <div className="flex-1">
                  <p className="font-outfit text-artden-muted text-xs uppercase tracking-widest mb-2">Art Den Studio</p>
                  <p className="font-cormorant text-xl font-medium text-white">37 E Belvidere Street</p>
                  <p className="font-outfit text-artden-muted text-sm mb-4">Nazareth, PA 18064</p>
                  <div className="flex flex-wrap gap-3">
                    <a
                      href="https://maps.google.com/?q=37+E+Belvidere+Street+Nazareth+PA+18064"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 bg-artden-coral text-white text-xs font-semibold px-4 py-2 rounded-full hover:brightness-110 transition-all whitespace-nowrap"
                    >
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-navigation-fill text-xs"></i>
                      </span>
                      Get Directions
                    </a>
                    <a
                      href="tel:6103400314"
                      className="inline-flex items-center gap-1.5 border border-white/15 text-white/60 text-xs font-semibold px-4 py-2 rounded-full hover:border-artden-coral hover:text-artden-coral transition-all whitespace-nowrap"
                    >
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-phone-line text-xs"></i>
                      </span>
                      610-340-0314
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right — Map */}
          <div className="flex flex-col gap-4">
            <div className="w-full h-80 md:h-96 rounded-2xl overflow-hidden border border-white/8" style={{ boxShadow: '0 0 0 1px rgba(255,67,34,0.1)' }}>
              <iframe
                title="Art Den Studio — 37 E Belvidere Street, Nazareth PA"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3043.847!2d-75.3094!3d40.7264!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c430b4b3b0c5c5%3A0x1234567890abcdef!2s37%20E%20Belvidere%20St%2C%20Nazareth%2C%20PA%2018064!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* Contact cards */}
            <div className="grid grid-cols-2 gap-3">
              <a
                href="tel:6103400314"
                className="flex items-center gap-3 rounded-xl border border-white/8 p-4 hover:border-artden-coral/40 transition-all group"
                style={{ background: '#1a1a1a' }}
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-lg group-hover:bg-artden-coral/20 transition-all" style={{ background: 'rgba(255,67,34,0.1)' }}>
                  <i className="ri-phone-fill text-artden-coral"></i>
                </div>
                <div>
                  <p className="font-outfit text-artden-muted text-xs">Call Us</p>
                  <p className="font-outfit text-white text-sm font-semibold">610-340-0314</p>
                </div>
              </a>
              <a
                href="mailto:info@artdenstudio.com"
                className="flex items-center gap-3 rounded-xl border border-white/8 p-4 hover:border-artden-amber/40 transition-all group"
                style={{ background: '#1a1a1a' }}
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-lg group-hover:bg-artden-amber/20 transition-all" style={{ background: 'rgba(255,179,0,0.1)' }}>
                  <i className="ri-mail-fill text-artden-amber"></i>
                </div>
                <div>
                  <p className="font-outfit text-artden-muted text-xs">Email</p>
                  <p className="font-outfit text-white text-xs font-semibold">info@artdenstudio.com</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
